export default __webpack_public_path__ + "static/media/mailboxImage.8eea4e00.png";